// Tenant List
export const TENANT_LIST_REQUEST = 'TENANT_LIST_REQUEST';
export const TENANT_LIST_SUCCESS = 'TENANT_LIST_SUCCESS';
export const TENANT_LIST_FAIL = 'TENANT_LIST_FAIL';
export const TENANT_LIST_RESET = 'TENANT_LIST_RESET';

// Tenant List Unpaged
export const TENANT_LIST_UNPAGED_REQUEST = 'TENANT_LIST_UNPAGED_REQUEST';
export const TENANT_LIST_UNPAGED_SUCCESS = 'TENANT_LIST_UNPAGED_SUCCESS';
export const TENANT_LIST_UNPAGED_FAIL = 'TENANT_LIST_UNPAGED_FAIL';
export const TENANT_LIST_UNPAGED_RESET = 'TENANT_LIST_UNPAGED_RESET';

// Tenant Details
export const TENANT_DETAILS_REQUEST = 'TENANT_DETAILS_REQUEST';
export const TENANT_DETAILS_SUCCESS = 'TENANT_DETAILS_SUCCESS';
export const TENANT_DETAILS_FAIL = 'TENANT_DETAILS_FAIL';
export const TENANT_DETAILS_RESET = 'TENANT_DETAILS_RESET';

// Create Tenant
export const TENANT_CREATE_REQUEST = 'TENANT_CREATE_REQUEST';
export const TENANT_CREATE_SUCCESS = 'TENANT_CREATE_SUCCESS';
export const TENANT_CREATE_FAIL = 'TENANT_CREATE_FAIL';
export const TENANT_CREATE_RESET = 'TENANT_CREATE_RESET';

// Update Tenant
export const TENANT_UPDATE_REQUEST = 'TENANT_UPDATE_REQUEST';
export const TENANT_UPDATE_SUCCESS = 'TENANT_UPDATE_SUCCESS';
export const TENANT_UPDATE_FAIL = 'TENANT_UPDATE_FAIL';
export const TENANT_UPDATE_RESET = 'TENANT_UPDATE_RESET';

// Delete Tenant
export const TENANT_DELETE_REQUEST = 'TENANT_DELETE_REQUEST';
export const TENANT_DELETE_SUCCESS = 'TENANT_DELETE_SUCCESS';
export const TENANT_DELETE_FAIL = 'TENANT_DELETE_FAIL';
export const TENANT_DELETE_RESET = 'TENANT_DELETE_RESET';